import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminSecurityComponent } from './admin-security.component';

const routes: Routes = [
  {
    path: '',
    component: AdminSecurityComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminSecurityRoutingModule {}
